import React, { useState, useEffect } from 'react';
import { 
  Box, 
  TextField, 
  Button, 
  Grid, 
  Paper, 
  Typography, 
  Alert,
  CircularProgress
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { API_ENDPOINTS } from '../../../../config/api';

// Custom event name for application settings type updates
const APP_SETTINGS_TYPE_UPDATED_EVENT = 'app_settings_type_updated';

const AddApplicationType = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    type: '',
    slug: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  // Function to convert string to slug
  const convertToSlug = (text) => {
    return text
      .toLowerCase()
      .replace(/[^\w ]+/g, '')
      .replace(/ +/g, '-');
  };

  // Handle input change
  const handleChange = (e) => {
    const { name, value } = e.target;
    
    setFormData({
      ...formData,
      [name]: value,
      // If type field is changed, automatically update the slug
      ...(name === 'type' ? { slug: convertToSlug(value) } : {})
    });
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    
    try {
      const token = localStorage.getItem('token');
      
      if (!token) {
        navigate('/login');
        return;
      }

      if (!formData.type) {
        setError('Type name is required');
        setLoading(false);
        return;
      }

      // Create application type data
      const applicationTypeData = { 
        type: formData.type,
        slug: formData.slug
      };

      // Send request to create application type
      const response = await axios.post(API_ENDPOINTS.APPLICATION_TYPES.BASE, applicationTypeData, {
        headers: { 
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      if (response.data.success) {
        setSuccess(true);
        
        // Dispatch custom event to trigger sidebar refresh
        window.dispatchEvent(new CustomEvent(APP_SETTINGS_TYPE_UPDATED_EVENT));
        
        setTimeout(() => {
          navigate('/application-setting-types');
        }, 2000);
      }
    } catch (error) {
      console.error('Error creating application type:', error);
      setError(error.response?.data?.message || 'Failed to create application type');
    } finally {
      setLoading(false);
    }
  };
  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Paper sx={{ p: 3 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
            <Button 
              startIcon={<ArrowBackIcon />} 
              onClick={() => navigate('/application-setting-types')} 
              sx={{ mr: 2 }}
            >
              Back 
            </Button>
            {/* <Typography variant="h5">
              Create New Application Type
            </Typography> */}
          </Box>

          {error && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {error}
            </Alert>
          )}

          {success && (
            <Alert severity="success" sx={{ mb: 2 }}>
              Application type created successfully!
            </Alert>
          )}

          <Box component="form" onSubmit={handleSubmit} sx={{ mt: 2 }}>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={4}>
                <TextField
                  fullWidth
                  label="Type"
                  name="type"
                  value={formData.type}
                  onChange={handleChange}
                  required
                />
              </Grid>
              
              <Grid item xs={12} sm={4}>
                <TextField
                  fullWidth
                  label="Slug"
                  name="slug"
                  value={formData.slug}
                  InputProps={{
                    readOnly: true,
                  }}
                  required
                />
              </Grid>
              
              <Grid item xs={12}>
                <Box sx={{ mt: 2 }}>
                  <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    disabled={loading}
                  >
                    {loading ? <CircularProgress size={24} /> : 'Create Application Type'}
                  </Button>
                  <Button
                    variant="outlined"
                    color="secondary"
                    onClick={() => navigate('/application-setting-types')}
                    sx={{ ml: 2 }}
                    disabled={loading}
                  >
                    Cancel
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Paper>
      </Grid>
    </Grid>
  );
};

export default AddApplicationType;
